<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>
        </div>

        <div class="pl-3 pt-3 pr-3 w-crud-form">                
            <template>
                <v-row>
                                    <v-col cols="12">
                                        <v-text-field 
                                            v-model="productForm.name" 
                                            label="Nombre" 
                                            outlined 
                                            hide-details>
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="productForm.category_id"
                            :items="categories"
                            label="Seleccione categoría"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"                            
                            @change="handleSelectCategory"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('brand_id') > -1">
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="productForm.brand_id"
                            :items="brands"
                            label="Seleccione marca"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('type_id') > -1">
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="productForm.type_id"
                            :items="types"
                            label="Seleccione modelo"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('capacity_id') > -1">
                    <v-col cols="12">
                        <v-combobox
                        v-model="select"
                        :items="materialReagents"
                        label="Seleccione Material/Reactivo"
                        clearable
                        hide-details=""
                        dense
                        outlined
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('color_id') > -1">
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="productForm.color_id"
                            :items="colors"
                            label="Seleccione color"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('name') > -1">
                    <v-col cols="12">
                        <v-text-field v-model="productForm.name" label="Nombre" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('code') > -1">
                    <v-col cols="12">
                        <v-text-field v-model="productForm.code" label="Código" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('sku') > -1">
                    <v-col cols="12">
                        <v-text-field v-model="productForm.sku" label="SKU" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('barcode') > -1">
                    <v-col cols="12">
                        <v-text-field v-model="productForm.barcode" label="Código de barras" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="fields_show_all || fields_show.indexOf('sn') > -1">
                    <v-col cols="12">
                        <v-text-field v-model="productForm.sn" label="SN" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="productForm.base_price" label="Precio Venta" type="number" outlined hide-details></v-text-field>
                    </v-col>
                </v-row>
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions} from 'vuex'

import ArrayTools from '../../helpers/ArrayTools'

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            materialReagents: [
            'Reactivo',
            'Material',
            ],
            field_phones: [
                'brand_id',
                'type_id',
                'capacity_id',
                'color_id',
                'name',
                'code',
                'sn'
            ],
            field_chips: [
                'code',
                'barcode',
                'brand_id',
                'type_id',
                'name',
            ],
            field_accesorios: [
                'sku',
                'barcode',
                'name',
                'capacity_id',
                'color_id',
                'brand_id',
                'type_id'
            ],
            fields_show_all: true,
            fields_show: [],
            productForm: {
                id: null,
                category_id: null,
                brand_id: null,
                type_id: null,
                capacity_id: null,
                color_id: null,
                name: null,
                code: null,
                sku: null,
                barcode: null,
                sn: null,
                base_price: null
            }
        }
    },
    computed: {
        ...mapState('categories', [
            'categories'
        ]),
        ...mapState('brands', [
            'brands'
        ]),
        ...mapState('types', [
            'types'
        ]),
        ...mapState('capacities', [
            'capacities'
        ]),
        ...mapState('colors', [
            'colors'
        ])
    },
    methods: {
        ...mapActions('categories', [
            'getCategories',
        ]),
        ...mapActions('brands', [
            'getBrands',
        ]),
        ...mapActions('types', [
            'getTypes',
        ]),
        ...mapActions('capacities', [
            'getCapacities',
        ]),
        ...mapActions('colors', [
            'getColors',
        ]),
        ...mapActions('products', [
            'store',
            'update'
        ]),
        showForm(title, action, product = null) {
            this.clearData()
            this.titleForm = title
            this.action = action
            if (product) {
                this.setProduct(product)
            }
            this.drawer = !this.drawer
        },
        clearData() {
            this.fields_show_all = true
            this.titleForm = null
            this.action = null
            this.productForm.id = null
            this.productForm.category_id = null
            this.productForm.brand_id = null
            this.productForm.type_id = null
            this.productForm.capacity_id = null
            this.productForm.color_id = null
            this.productForm.name = null
            this.productForm.code = null
            this.productForm.sku = null
            this.productForm.barcode = null
            this.productForm.sn = null
            this.productForm.base_price = null
        },
        setProduct(product) {
            this.productForm.id = product.id
            this.productForm.category_id = product.category_id
            this.productForm.brand_id = product.brand_id
            this.productForm.type_id = product.type_id
            this.productForm.capacity_id = product.capacity_id
            this.productForm.color_id = product.color_id
            this.productForm.name = product.name
            this.productForm.code = product.code
            this.productForm.sku = product.sku
            this.productForm.barcode = product.barcode
            this.productForm.sn = product.sn
            this.productForm.base_price = product.base_price
            this.handleSelectCategory(this.productForm.category_id)
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        handleCancel() {
            this.closeForm()
        },
        customText(item){
            let text = item.name
            
            return text
        },
        customTextCapacity(item){
            let text = item.description
            
            return text
        },
        async handleStore() {
            await this.store(this.productForm)
            this.closeForm()
        },
        async handleUpdate() {
            await this.update(this.productForm)
            this.closeForm()
        },
        handleSelectCategory(value) {
            let category = ArrayTools.getElementById(this.categories, parseInt(value))
            if (category.name == 'Accesorios') {
                this.fields_show = this.field_accesorios
                this.fields_show_all = false
            } else if (category.name == 'Celulares') {
                this.fields_show = this.field_phones
                this.fields_show_all = false
            } else if (category.name == 'Chips') {
                this.fields_show = this.field_chips
                this.fields_show_all = false
            }            
        }
    },
    mounted() {
        this.getBrands()
        this.getTypes()
        this.getCapacities()
        this.getColors()
    }
}
</script>

<style scoped>

</style>